import(/* webpackMode: "eager", webpackExports: ["ConsentBanner"] */ "/tmp/8df0e6997faac0c/components/consent/ConsentBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/tmp/8df0e6997faac0c/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/tmp/8df0e6997faac0c/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProgress"] */ "/tmp/8df0e6997faac0c/components/layout/ScrollProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/tmp/8df0e6997faac0c/components/layout/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTracker"] */ "/tmp/8df0e6997faac0c/components/tracking/PageTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadImages"] */ "/tmp/8df0e6997faac0c/components/ui/PreloadImages.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/font/google/target.css?{\"path\":\"app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-sans\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/styles/globals.css");
